import React from "react";
import PropTypes from "prop-types";
import { Typography, Box, makeStyles } from "@material-ui/core";
import CustomButton from "../button/CustomButton";
import {Skeleton} from "@material-ui/lab";
import { useI18N } from "../../../common/common";
import ArrowBackIcon from "../streamline-icon/ArrowBackIcon";

const useStyles = makeStyles((theme) => ({
    p0: {
        padding: theme.spacing(0)
    },
}));

const PointsPlatformHeader = ({title, onClick, loading}) => {
    const classes = useStyles();
    const {i18n} = useI18N();

    const handleClick = () => {
        if (onClick && !loading) {
            onClick();
        }
    };

    return (
        <>
            <Box
                mt={1.5}
                mb={1.5}
            >
                <CustomButton
                    className={classes.p0}
                    disableElevation
                    color={"black"}
                    startIcon={!loading ? <ArrowBackIcon /> : <Skeleton />}
                    size={"small"}
                    onClick={handleClick}
                >
                    {!loading ? i18n("common.label.back") : <Skeleton/>}
                </CustomButton>
            </Box>

            <Box
                mt={3}
                mb={4}
            >
                <Typography
                    className={classes.headerText}
                    variant={"h1"}
                >
                    {!loading ? title : <Skeleton/>}
                </Typography>
            </Box>
        </>
    );
};

PointsPlatformHeader.propTypes = {
    title: PropTypes.string,
    onClick: PropTypes.func,
    loading: PropTypes.bool
};

export default PointsPlatformHeader;
